import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { api } from "../../lib/api";

export default function SettingsPanel() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then(r => setS(r.data)); }, []);
  if (!s) return null;
  const save = async () => {
    try {
      await api.patch("/admin/settings", { whatsapp_number: s.whatsapp_number, new_fee: Number(s.new_fee), followup_fee: Number(s.followup_fee) });
      toast.success("Settings saved");
    } catch { toast.error("Failed to save"); }
  };
  return (
    <div className="mt-6 bg-white border border-slate-200 rounded-xl p-6 max-w-lg space-y-5" data-testid="settings-panel">
      <div className="space-y-1"><Label>Clinic WhatsApp number</Label><Input value={s.whatsapp_number} onChange={e => setS({ ...s, whatsapp_number: e.target.value })} data-testid="settings-whatsapp-input" /></div>
      <div className="space-y-1"><Label>New patient fee (₹)</Label><Input type="number" value={s.new_fee} onChange={e => setS({ ...s, new_fee: e.target.value })} data-testid="settings-new-fee-input" /></div>
      <div className="space-y-1"><Label>Follow-up fee (₹)</Label><Input type="number" value={s.followup_fee} onChange={e => setS({ ...s, followup_fee: e.target.value })} data-testid="settings-followup-fee-input" /></div>
      <Button onClick={save} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="settings-save-btn">Save settings</Button>
    </div>
  );
}
